export default __webpack_public_path__ + "static/media/Spectrum-at-Fairmont-Makati.06911cd1.PNG";